import classNames from "clsx";

import { useSnapshot } from "valtio";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";

import { SummaryDivider } from "./components/SummaryDivider";
import { useEffect } from "react";
import { letterStore } from "src/js/stores/letter/store";

interface PhysicalSendSummarySectionProps {
  onTotalCostCalculated?: (totalCost: number) => void;
}

const LETTER_COST_IN_CREDITS = 1;

export const PhysicalSendSummaryCreditsSection: React.FC<PhysicalSendSummarySectionProps> = ({
  onTotalCostCalculated,
}) => {
  const { t } = useTranslation();

  const { selectedRecipientIds } = useSnapshot(letterStore);
  const quantityOfLetters = selectedRecipientIds?.length ?? 1;
  const totalCostInCredits = quantityOfLetters * LETTER_COST_IN_CREDITS;

  useEffect(() => {
    onTotalCostCalculated?.(totalCostInCredits);
  }, [onTotalCostCalculated, totalCostInCredits]);

  return (
    <div
      className={classNames("p-4", "bg-white", "rounded-b-lg")}
      data-testid="site-letter-payment-summary-summary-section"
    >
      <div data-testid="product-details">
        <span className={classNames("font-semibold", "text-base", "text-text-base-primary")}>
          {t("sites.letters.letter_summary")}
        </span>
        <div className={classNames("mt-4", "flex", "justify-between")}>
          <div className={classNames("flex", "font-medium")}>
            <span className="text-text-base-secondary">{quantityOfLetters}x</span>

            <span className={classNames("ml-2", "text-text-base-primary")}>{t("sites.letters.standard_letter")}</span>
          </div>
          <span className={classNames("flex", "text-text-base-primary")}>
            {t("sites.letters.nr_of_credits", { credit: 1 })}
          </span>
        </div>
      </div>

      <SummaryDivider />

      <div
        className={classNames(
          "mt-4",
          "flex",
          "justify-between",
          "font-semibold",
          "text-base",
          "leading-6",
          "text-text-base-primary"
        )}
        data-testid="total"
      >
        <span className="flex">{t("sites.letters.total_due")}</span>
        <span className="flex" data-testid="credits">
          {t("sites.letters.nr_of_credits", { credit: totalCostInCredits })}
        </span>
      </div>
    </div>
  );
};
